module.exports = __webpack_public_path__ + "static/smart_wyjatkowe-f0941f06d91a84434b767f2f584393c2.png";